import React from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload } from 'antd'

const UploadBtn = props => {
  const { btnName, accept, callBack, buttonType } = props
  const beforeUploadHandler = file => {
    if (accept) {
      let fileArr = file.name.split('.')
      let extensionName = fileArr[fileArr.length - 1]
      if (accept.indexOf(extensionName) === -1) {
        file.status = 'error'
        message.error('File extension name must be ' + accept)
        return false
      }
    } else {
      if (file.name.indexOf('.xlsx') === -1 && file.name.indexOf('.xls') === -1) {
        file.status = 'error'
        message.error('File extension name must be xlsx or xls!')
        return false
      }
    }
  }
  const uploadProps = {
    name: 'file',
    showUploadList: false,
    beforeUpload: beforeUploadHandler,
    accept: accept || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
    onChange(info) {
      if (!!info.fileList && info.fileList.length > 1) {
        info.fileList.splice(0, 1)
      }
      if (info.file.status === 'error') {
        const errMsg = info.file.error ? info.file.error.error_message : null
        if (!errMsg) {
          return
        }
        message.error(errMsg)
      }

      if (info.file.status === 'done') {
        message.success(`Upload Successfully.`)
        // 查询
        callBack && callBack()
      }
    }
  }

  const uploadAarrOrderRequest = options => {
    var form = new FormData()
    form.append('file', options.file)
    props.uploadAjax(form)
  }
  const uploadRequest = {
    customRequest: uploadAarrOrderRequest
  }

  return (
    <Upload {...uploadProps} {...uploadRequest}>
      <Button type={buttonType || 'primary'} icon={<UploadOutlined />}>
        {btnName || 'Upload'}
      </Button>
    </Upload>
  )
}

export default UploadBtn
